import "./login.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap/";
import Logo from "./../../assets/logo.svg";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";

function Login() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const navigate = useNavigate();

  const handlePhone = (event) => {
    setPhone(event.target.value);
  };

  const validatePhone = (phone) => {
    const regex = /^(?:\+91\s?)?[6-9]\d{9}$/;
    const isValid = regex.test(phone);
    setPhoneError(!isValid);
    return isValid;
  };

  const PostLogin = () => {
    setLoading(true);

    const payload = {
      phone: phone,
    };

    axios
      .post(baseUrl + "auth/auth/login/", payload)
      .then((response) => {
        console.log("Login success:", response.data);
        localStorage.setItem("isLoggedIn", "true");
        window.dispatchEvent(new Event('authChange'));
        setLoading(false);
        const dataToSend = { phone };
        navigate("/otp", { state: { data: dataToSend }, replace: true });
      })
      .catch((error) => {
        console.error("Login error:", error);
        setLoading(false);
        if (error.response) {
          if (error.response.status === 400) {
            alert("Invalid phone number or authorization issue.");
          } else {
            alert("Something went wrong: " + error.response.status);
          }
        } else if (error.request) {
          alert("No response from server. Please try again.");
        } else {
          alert("Error: " + error.message);
        }
      });
  };

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img src={Logo} className="logo" alt="Logo" />
          <div className="business-name">Onescribe Business Panel</div>
        </div>

        <Card className="login-card card mt-5 rounded-4">
          <div className="login-title">Login</div>

          <TextField
            id="phone"
            className="mt-4"
            label="Phone Number"
            variant="outlined"
            size="small"
            value={phone}
            onChange={handlePhone}
            error={phoneError}
            helperText={phoneError ? "Invalid Phone Number" : ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5 mb-3"
            onClick={() => {
              if (validatePhone(phone)) {
                PostLogin();
              }
            }}
            disabled={loading}
          >
            Submit
          </Button>

          <div className="spiner-container">
            {loading && (
              <TailSpin
                className="mt-5"
                height="30"
                width="30"
                radius="1"
                color="#ffbe00"
                ariaLabel="loading"
                visible={loading}
              />
            )}
          </div>
        </Card>
      </div>

      <a href="tel:+919481815122" className="contact">
        ⓘ Contact Us
      </a>
    </section>
  );
}

export default Login;